import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { translate, t } from "react-multi-lang";
import {
    forgotPasswordStart,
} from "../../store/actions/UserAction";
import "./Forgot.css"

const Forgot = (props) => {

    const [forgotPasswordInputData, setForgotPasswordInputData] = useState({});
    
    useEffect(() => {
        const prevTitle = document.title;
        document.title = "Forgot Password | Rebel";
        return () => {
            document.title = prevTitle;
        };
    }, []);

    const handleForgotPassword = (event) => {
        event.preventDefault();
        props.dispatch(forgotPasswordStart(forgotPasswordInputData));
    };

    return (
        <div className="signin-wrapper">
            <div className="signin-card">

                {/* LEFT SIDE */}
                <div className="signin-left">
                    <div className="logo-wrapper">
                        <img
                            src="https://admin.rebeltv.me/rebel-homepage-assets/logo.png"
                            alt="logo"
                            className="signin-logo d-inline"
                        />
                    </div>

                    <h2 className="signin-title">FORGOT PASSWORD</h2>

                    <p className="signin-subtitle">
                        Enter your email to reset your password.
                    </p>

                    <form onSubmit={handleForgotPassword} method="post">
                        <div className="auth-form-group">
                            <input
                                type="email"
                                placeholder="Email"
                                className="email-input"
                                autoComplete="off"
                                required
                                value={forgotPasswordInputData.email}
                                name="email"
                                onChange={(event) =>
                                    setForgotPasswordInputData({
                                        ...forgotPasswordInputData,
                                        email: event.currentTarget.value,
                                    })
                                }
                            />
                        </div>

                        <button
                            className="signin-btn"
                            type="submit"
                            onClick={handleForgotPassword}
                            disabled={props.forgotPassword.buttonDisable}>
                            {props.forgotPassword.loadingButtonContent !==
                                null
                                ? props.forgotPassword.loadingButtonContent
                                : "Forgot Password"}
                        </button>

                        {/* LOGIN LINK */}
                        <p className="signup-text">
                            Already have an account?
                            <a href="/signin"> Sign in</a>
                        </p>
                    </form>
                </div>

            </div>
        </div>
    );
}

const mapStateToPros = (state) => ({
    forgotPassword: state.users.forgotPasswordInputData
});

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(translate(Forgot));